import { createAsyncThunk } from '@reduxjs/toolkit';

import { getCurrentFlagListService } from 'services/current_flags.service';

export const getCurrentFlagList = createAsyncThunk(
  'currentFlag/getList',
  async (_, thunkApi) => {
    try {
      const response = await getCurrentFlagListService();

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
